import React from "react";
import PropTypes from "prop-types";
var ConsentBannerBody = function (props) {
    var children = props.children;
    return (React.createElement("div", { className: "fr-consent-banner__content" },
        React.createElement("p", { className: "fr-text--sm" }, children)));
};
ConsentBannerBody.defaultProps = { __TYPE: "ConsentBannerBody" };
ConsentBannerBody.propTypes = { __TYPE: PropTypes.string };
export default ConsentBannerBody;
